// SkipDaysOutBadge — colour-coded chip for the inventory list / detail.
//
// Drives off `active_job_delivered_at` from the inventory summary
// (added in §7.9). >14d = amber, >30d = red. Renders nothing when
// the unit isn't out / no delivered_at.

import styles from './SkipDaysOutBadge.module.css';

export interface SkipDaysOutBadgeProps {
  activeJobDeliveredAt: string | null;
}

function daysSince(iso: string): number | null {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const ms = Date.now() - d.getTime();
  return Math.floor(ms / 86_400_000);
}

export function SkipDaysOutBadge({
  activeJobDeliveredAt,
}: SkipDaysOutBadgeProps): JSX.Element | null {
  if (!activeJobDeliveredAt) return null;
  const days = daysSince(activeJobDeliveredAt);
  if (days === null || days <= 14) return null;
  const variant = days > 30 ? 'high' : 'mid';
  return (
    <span className={`${styles.badge} ${variant === 'high' ? styles.high : styles.mid}`}>
      {days} days out
    </span>
  );
}
